import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useMotionTemplate } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

// Optimize Cloudinary URLs for faster loading
const optimizeImageUrl = (url, width) => {
  if (!url || !url.includes('cloudinary.com')) return url;
  return url.replace('/upload/', `/upload/f_auto,q_auto,w_${width}/`);
};

export const ScrollImageComparison = ({ beforeImage, afterImage, altBefore = 'Before', altAfter = 'After', children }) => {
    const containerRef = useRef(null);
    
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start start", "end end"]
    });

    const clipPercentage = useTransform(scrollYProgress, [0.1, 0.9], [100, 0]);
    const clipPath = useMotionTemplate`inset(0 ${clipPercentage}% 0 0)`;
    const sliderLeftPosition = useTransform(clipPercentage, v => 100 - v);
    const sliderLeft = useMotionTemplate`calc(${sliderLeftPosition}% - 2px)`;

    const optimizedBefore = optimizeImageUrl(beforeImage, 1200);
    const optimizedAfter = optimizeImageUrl(afterImage, 1200);

    return (
        <div ref={containerRef} className="relative w-full h-[300vh] bg-brand-sand">
            <div className="sticky top-0 w-full h-screen overflow-hidden flex items-center justify-center">
                
                <div className="absolute inset-0 w-full h-full">
                    <img
                        src={optimizedBefore}
                        alt={altBefore}
                        className="w-full h-full object-cover object-center"
                        draggable="false"
                        loading="lazy"
                        decoding="async"
                    />
                </div>

                <motion.div
                    className="absolute inset-0 w-full h-full"
                    style={{ clipPath }}
                >
                    <img
                        src={optimizedAfter}
                        alt={altAfter}
                        className="w-full h-full object-cover object-center"
                        draggable="false"
                        loading="lazy"
                        decoding="async"
                    />
                </motion.div>

                <motion.div
                    className="absolute top-0 bottom-0 w-1 bg-white/80 shadow-[0_0_15px_rgba(0,0,0,0.5)] z-20"
                    style={{ left: sliderLeft }}
                >
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full h-12 w-12 flex items-center justify-center shadow-xl text-brand-darkSage">
                        <FiChevronLeft className="w-5 h-5 -mr-1" />
                        <FiChevronRight className="w-5 h-5 -ml-1" />
                    </div>
                </motion.div>

                <div className="relative z-30 pointer-events-none w-full h-full flex flex-col justify-end items-center pb-24 md:pb-32 px-6">
                    {children}
                </div>
            </div>
        </div>
    );
};